<template>
    <div>
        <b-modal
            id="nationalTrademarkSearchFormModal"
            centered
            size="xl"
            no-close-on-backdrop
            ref="nationalTrademarkSearchFormModal"
            :title=" $t('nationalTrademarkSearchResponsible.info')"
            :cancel-title=" $t('others.cancel_title')"
            :ok-title=" $t('others.ok_title')"
            cancel-variant="outline-secondary"
            @ok.prevent="addOrUpdate"
            hide-footer
        >
        <b-card no-body class="border mt-1">
            <b-card-header class="p-1">
              <b-card-title class="font-medium-2">
                <feather-icon icon="LockIcon" size="18" />
                <span class="align-middle ml-50">{{  $t('nationalTrademarkSearchResponsible.responsible')  }}</span>
              </b-card-title>
            </b-card-header>
            <!--eslint-disable-->
            <table class="table table-striped table-bordered">
              <tbody>
                <tr v-for="nationalTrademarkSearchResponsibleItem in nationalTrademarkSearchResponsibleList" :key="nationalTrademarkSearchResponsibleItem.id">
                  <td >
                      <b-form-checkbox @change="changeResponsible($event, nationalTrademarkSearchResponsibleItem.id, nationalTrademarkSearchResponsibleItem.mailContactTypeId)" />                                 
                  </td>
                  <td>{{  nationalTrademarkSearchResponsibleItem.name  }}</td>
                  <td>{{ nationalTrademarkSearchResponsibleItem.email  }}</td>
                  <td>
                    <b-form-select v-model="nationalTrademarkSearchResponsibleItem.mailContactTypeId" value-field="id" text-field="name" :options="mailContactTypeList" />
                  </td>
                  <td>{{ nationalTrademarkSearchResponsibleItem.responsibleField  }}</td>
                </tr>
              </tbody>
            </table>
          </b-card>
        </b-modal>
    </div>
</template>
<script>
export default{
  props: {
      getNationalTrademarkSearchResponsibleList: {type: Function},
    },
  data(){
    return {
      id: 0,
      nationalTrademarkSearchResponsibleList:[],
      mailContactTypeList:[],
    }
  },
  methods:{
    changeResponsible(selected, clientResponsibleId, mailContactTypeId) {
      const controller = { name: 'NationalTrademarkSearchResponsible' }
      if (selected == true) { 
        const data = { nationalTrademarkSearchId: this.nationalTrademarkSearchId, clientResponsibleId: clientResponsibleId, mailContactTypeId: mailContactTypeId }
        const payload = { data: data, controller: controller }
        this.$store.dispatch('moduleAuth/save', payload).then((response) => {
          if (response.data.resultStatus == true) {
            this.getNationalTrademarkSearchResponsibleList()
            this.$SaveAlert()
          } else {
            this.$WarningAlert(response.data.resultMessage)
          }
        })
      }
    },
    showInfo(nationalTrademarkSearchId, clientId) {
      this.$refs['nationalTrademarkSearchFormModal'].show()
          this.nationalTrademarkSearchId= nationalTrademarkSearchId
          const data = {clientId: clientId,nationalTrademarkSearchId:nationalTrademarkSearchId}
          const controller = {name: 'ClientResponsible', actionName:'GetClientResponsibleListForModules'}
          const payload = {data: data, controller: controller}
          this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
              if(response.data.resultStatus == true){    
                  this.nationalTrademarkSearchResponsibleList = response.data.clientResponsibleList
                  this.mailContactTypeList = response.data.mailContactTypeList
              } else {
                  this.$bvModal.hide('nationalTrademarkSearchFormModal')
                  this.$WarningAlert(response.data.resultMessage)
              }  
          }) 
      },
  }
}
</script>